module.exports = __webpack_public_path__ + "img/360.7544e789.svg";